import { MzImage } from '../MzImage';
import { Mapper, NilUtils, ReadOnly } from 'module/Common';
import { MzImageResolutionName } from 'module/Model/MzImage';
import { Localized } from 'module/Model/Localized';
import includes from 'lodash-es/includes';

/**
 * PostListItem
 */

export type PostListItem = ReadOnly<PostListItem.Shape>;

export namespace PostListItem {
  export type Shape = {
    id: number;
    date: Date;
    title: Localized<string>;
    categories: Array<number>;
    overviewImg: MzImage | null;
    overviewColor: string;
    overviewTitle: Localized<string>;
  };

  const create = (input: PostListItem) => input;

  export const mapper = Mapper.mapSchema(
    {
      id: Mapper.num,
      date: Mapper.date,
      title: Localized.mapperWithDefault('Sans Nom', 'No Name'),
      categories: Mapper.arrayOrEmptyIfNull(Mapper.num),
      overview_img: Mapper.nullable(MzImage.mapper),
      overview_color: Mapper.defaultIfNull(Mapper.str, '#EEEEEE'),
      overview_title: Localized.mapperWithDefault('Sans Nom', 'No Name'),
    },
    ({ id, date, title, overview_img, categories, overview_color, overview_title }) =>
      create({
        id,
        date,
        title,
        overviewImg: overview_img,
        categories,
        overviewColor: overview_color,
        overviewTitle: overview_title,
      })
  );

  export const getId = (model: PostListItem): number => model.id;
  export const getTitle = (model: PostListItem): Localized<string> => model.title;
  export const getOverviewColor = (model: PostListItem): string => model.overviewColor;
  export const getCategoryIds = (model: PostListItem): Array<number> => model.categories;
  export const hasCategoryId = (model: PostListItem, catId: number): boolean => includes(getCategoryIds(model), catId);
  export const hasOnOfCategoryId = (model: PostListItem, catIds: Array<number>): boolean => {
    const postcatIds = getCategoryIds(model);
    return postcatIds.filter(catId => includes(catIds, catId)).length > 0;
  };
  export const getOverviewImage = (model: PostListItem): MzImage | null => model.overviewImg;
  export const getOverviewTitle = (model: PostListItem): Localized<string> => model.overviewTitle;
  export const getOverviewRatio = (model: PostListItem): number => {
    return (
      NilUtils.bubbleNull<PostListItem, MzImage, number>(v => getOverviewImage(v), v => MzImage.getRatio(v))(model) || 1
    );
  };
  export const getOverviewImageSrc = (model: PostListItem, size: MzImageResolutionName): string | null => {
    return MzImage.getUrlOrNull(getOverviewImage(model), size);
  };
  export const getOverviewImageRatio = (model: PostListItem): number => {
    const overview = getOverviewImage(model);
    if (overview === null) {
      return 1;
    }
    return MzImage.getRatio(overview);
  };
}



// WEBPACK FOOTER //
// ./src/module/Model/PostList/PostListItem.ts